import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';

import { FeatureFlag } from '@swf/core/enums';
import useFeature from '@swf/core/hooks/useFeature';
import { select } from '@swf/core/store';

const MetaNoIndex: React.FC = () => {
  const meta = useSelector(select.page.getMeta);
  const localePrefix = useSelector(select.location.getLocaleURL);
  const embeddedRoute = useSelector(select.location.isEmbeddedRoute);
  const preventIndexingTranslatedPagesFlag = useFeature(FeatureFlag.PreventIndexingTranslatedPages);
  const preventIndexingTranslatedPages = preventIndexingTranslatedPagesFlag && localePrefix;

  if (!meta.noIndex && !preventIndexingTranslatedPages && !embeddedRoute) return null;

  return (
    <Helmet>
      <meta name="robots" content="noindex" />
    </Helmet>
  );
};

export default MetaNoIndex;
